import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

export const NavigationContext = createContext({ onNavigate: () => {} });

export const useNavigate = () => {
    return useContext(NavigationContext);
};
